import "./CardReaderList.scss";

import React from "react";
//import { Link } from "react-router-dom";
import request from "request"
import usesFeatures from "usesFeatures"
import { startCase } from "lodash"

import Input from "Input"
import Modal from "Modal"
import Table from "Table"
import Select from "Select"
import Button from "Button"
import Header from "Header"

// export default class CardReaderList extends React.PureComponent {
class CardReaderList extends React.PureComponent {
  state = {
    addingReader: false,
    authCode: "",
    venueId: "",
    deletingReader: null,
    deleting: false,
  }

  componentDidMount() {
    this.props.fetchData("/card_readers")
    this.props.fetchData("/venues")
  }

  setVenue = (venueId) => this.setState({venueId})

  submitReader = () => {
    const { venueId, authCode } = this.state
    const req = request.post("/card_readers", { venueId, authCode })
    req.then(({data}) => {
      if(data.cardReader.id) {
        this.setState({addingReader: false})
        this.props.fetchData("/card_readers")
      } else {
        console.log(data)
      }
    })
  }

  confirmDelete = () => {
    const reader = this.state.deletingReader
    if (!reader) return

    this.setState({ deleting: true })
    request.delete(`/card_readers/${reader.id}`)
      .then(() => {
        this.setState({ deletingReader: null, deleting: false })
        this.props.fetchData("/card_readers")
      })
      .catch(() => this.setState({ deleting: false }))
  }

  venueOptions = () => {
    if(!this.props.venues || this.props.venues.length == 0) return {}

    const options = {}
    this.props.venues.forEach((v) => { if(v.stripeLocationId) options[v.id] = v.name })
    return options
  }

  render() {
    if (!this.props.dataFetched) return false

    const { addingReader, authCode, venueId, deletingReader, deleting } = this.state
    return(
      <div className="CardReaderList">
        <Header
          text="Card Readers"
          subtitle="Another Work in Progress. Pump the breaks Vince."
        >
          <Button onClick={() => this.setState({addingReader: true})} text="Add New Reader" />
        </Header>

        <Table
          headers={{
            location: "Location",
            terminal: "Terminal",
            deviceType: "Type",
            serialNumber: "Serial Number",
            status: "Status",
            actions: "",
          }}
          formatters={{
            status: (cr) => <span className={`tag ${cr.status == "online" ? "is-success" : "is-danger"}`}>{ startCase(cr.status) }</span>,
            terminal: (cr) => cr.terminal ? `${cr.terminal.store} - ${cr.terminal.number}` : "—",
            deviceType: (cr) => startCase(cr.deviceType),
            actions: (cr) => <Button color="red" onClick={() => this.setState({deletingReader: cr})} text="Delete" />,
          }}
          rows={this.props.cardReaders || []}
        />

        <Modal
          open={addingReader}
          toggleModal={() => this.setState({addingReader: false})}
        >
          <Select
            label="Venue"
            prompt="Select Venue"
            options={this.venueOptions()}
            value={venueId}
            onChange={this.setVenue}
          />

          <Input
            label="Reader Code"
            value={authCode}
            onChange={(authCode) => this.setState({authCode})}
          />

          <div className="is-flex">
            <Button
              className="ml-auto"
              disabled={!(authCode && venueId)}
              onClick={this.submitReader}
              text="Register Reader"
            />
          </div>
        </Modal>

        <Modal
          open={!!deletingReader}
          title="Delete Card Reader"
          toggleModal={() => !deleting && this.setState({deletingReader: null})}
        >
          { deletingReader &&
            <div>
              <p>
                This deregisters <strong>{deletingReader.serialNumber}</strong> from Stripe and
                removes it from Catch. The physical reader can then be registered again at another
                venue with its reader code.
              </p>
              { deletingReader.terminal &&
                <p className="mt-2">
                  It is currently on <strong>Terminal #{deletingReader.terminal.number}</strong> at{" "}
                  <strong>{deletingReader.terminal.store}</strong>. That terminal stays active but
                  will no longer be able to take card payments until a new reader is added.
                </p>
              }
            </div>
          }

          <div className="is-flex mt-4">
            <Button
              onClick={() => this.setState({deletingReader: null})}
              text="Cancel"
            />
            <Button
              className="ml-auto"
              color="red"
              loading={deleting}
              onClick={this.confirmDelete}
              text="Delete Reader"
            />
          </div>
        </Modal>
      </div>
    )
  }
}

export default usesFeatures(["data"], CardReaderList)
